import Rotate90DegreesCcwRounded from '@mui/icons-material/Rotate90DegreesCcwRounded';
import { Box, Tooltip } from '@mui/material';
import React, { FC } from 'react';

import { tooltips } from '@components/Capture/helper';
import { CommonStyles, sxMR0 } from '@components/Capture/icons/styles';

interface IRotate90DegreesIconProps {
  onClick?: () => void;
}

const Rotate90DegreesIcon: FC<IRotate90DegreesIconProps> = ({ onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{ ...CommonStyles, ...sxMR0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Tooltip title={tooltips.Rotate90Degrees} arrow>
        <Rotate90DegreesCcwRounded />
      </Tooltip>
    </Box>
  );
};

export { Rotate90DegreesIcon };
